import {useUserPreferences} from './useUserPreferences';

export function usePreferredLocale(): string | undefined {
  return useUserPreferences().locale;
}
